import React, { useEffect, useState } from "react";
import { Autocomplete, TextField, FormControl } from "@mui/material";
import apiClient from "../lib/api";
import urlConstant from "../constants/urlConstants";
import { ConstructionOutlined } from "@mui/icons-material";

const CityField = ({
  formData,
  onChange,
  formContext,
  rawErrors = [],
  uiSchema,
  required,
}) => {
  const [cityLiaisonData, setCityLiaisonData] = useState([]);

  // Get label from uiSchema or default, and add * if required
  const baseLabel = uiSchema?.["ui:options"]?.label || "Select your city";
  const label = required ? `${baseLabel} *` : baseLabel;
  useEffect(() => {
    const fetchCityAndLiaisons = async () => {
      try {
        const response = await apiClient.get(
          urlConstant.City.GetAllCityAssociateWithLiaison
        );
        if (Array.isArray(response.data)) {
          setCityLiaisonData(response.data);

          const selectedCity = response.data.find(
            (c) => c.cityName === formData
          );

          if (selectedCity) {
            const liaisonMap = {};
            selectedCity.liaisonViewResponse?.forEach((liaison) => {
              liaisonMap[liaison.unqGuid] = `${liaison.firstName}`;
            });

            formContext.setCityLiaisonMapping?.(liaisonMap);
            formContext.setIsCityLiaisonMappingCalled?.(true);
          }
        }
      } catch (err) {
        console.error("Failed to fetch cities and liaisons:", err);
      }
    };

    fetchCityAndLiaisons();
  }, [formData, formContext]);

  useEffect(() => {
    if (cityLiaisonData !== null && cityLiaisonData.length > 0) {
      const cityNames = cityLiaisonData.map((city) => city.cityName);
      if (formData && !cityNames.includes(formData)) {
        formContext.setFormData?.((prev) => ({
          ...prev,
          formSubmissionDetails: {
            ...prev.formSubmissionDetails,
            city: "",
            communityLiaison: "",
          },
        }));
        formContext.setFormDataVersion?.(formContext.formDataVersion + 1);
      }
    }
  }, [cityLiaisonData]);
  const handleChange = (_, selectedCity) => {
    const selectedCityName = selectedCity?.cityName || "";
    onChange(selectedCityName);
    formContext.setWatchCity?.(selectedCityName);
    formContext.updateKeyedFormData?.(
      "formSubmissionDetails.communityLiaison",
      ""
    );

    const liaisonMap = {};
    selectedCity?.liaisonViewResponse?.forEach((liaison) => {
      liaisonMap[liaison.unqGuid] = `${liaison.firstName}`;
    });

    formContext.setCityLiaisonMapping?.(liaisonMap);
  };

  return (
    <FormControl fullWidth error={rawErrors?.length > 0}>
      <Autocomplete
        value={cityLiaisonData.find((c) => c.cityName === formData) || null}
        onChange={handleChange}
        options={cityLiaisonData}
        getOptionLabel={(option) => option.cityName || ""}
        isOptionEqualToValue={(option, value) =>
          option.cityName === value.cityName
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            error={rawErrors?.length > 0}
          />
        )}
      />
    </FormControl>
  );
};

export default CityField;
